import React from "react";
import { View, StyleSheet } from "react-native";
import { ThemeType } from "../../theme/theme";
import { useTheme } from "react-native-paper";
import { Text } from "../text/text";

interface SectionHeadlineParams {
  tx: string;
}

export const SectionHeadline = ({ tx }: SectionHeadlineParams) => {
  const { colors, spacing, fontSize } = useTheme() as ThemeType;

  const styles = StyleSheet.create({
    headline: {
      backgroundColor: colors.lightGrey,
      paddingVertical: spacing.smaller,
      marginTop: spacing.tiny,
      marginBottom: spacing.smaller,
    },
    headlineText: {
      fontSize: fontSize.medium,
      lineHeight: fontSize.medium,
      paddingHorizontal: spacing.medium,
    },
  })

  return (
    <View style={styles.headline}>
      <Text tx={tx} style={styles.headlineText} upperCase />
    </View>
  );
}